// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  .featured_fact_check_thumbnail_overlay_content {
    height: 120px;
    width: 69% !important;
  }

  .featured_fact_check_view_count {
    font-size: 12px;
  }
  .featured_fact_check_thumbnail_overlay_name_and_date {
    font-size: 12px !important;
  }
  .featured_fact_check_button {
    height: 22px;
    font-size: 9px;
  }
  .featured_story_fact_check_title {
    font-size: 18px;
  }
  .featured_story_fact_check_sub_title {
    font-size: 15px;
  }
  .featured_fact_check_image_component {
    width: 60% !important;
    position: relative;
  }
  .featured_story_fact_check_container_mobile_view {
    display: none;
  }

  .fact_check_trending_stories_title {
    font-size: 25px;
  }

  .fact_check_trending_container {
    border-radius: 8px;
  }
  .fact_category_wise_card_container {
    height: 190px;
    width: 30%;
  }
 
  .fact_check_trending_stories_container {
    padding: 0px 20px 35px 20px !important;
  }
  .fact_check_trending_stories_title_container {
    height: 70px;
  }
  .fact_check_trending_stories_title {
    font-size: 25px;
  }

  .featured_fact_check_title {
    width: 90%;
  }

  .join_us_feature_text {
    font-size: 18px;
  }
  .home_article_sec_column_inner_row_content_skeleton {
    width: 100% !important;
    height: 98% !important;
  }
  .home_article_second_column :where(.css-dev-only-do-not-override-zg0ahe).ant-skeleton.ant-skeleton-element .ant-skeleton-input {
    width: 660px !important;
    height: 350px !important;
  }
  .exposing_fake_news_first_column_image_skeleton {
    width: 100% !important;
    height: 100% !important;
  }

  .category_wise_card_container_skeleton {
    width: 280px !important;
    height: 180px !important;
  }
  .fact_check_party_container {
    grid-template-columns: 65% 30% !important;
  }

  .fact_check_first_column_card_container {
    height: 400px !important;
  }
  .fact_check_party_wise_module_title {
    font-size: 30px !important;
  }
  .donation_first_row_container > text {
    font-size: 12px;
  }
  .donation_first_row_container_ta > text {
    font-size: 13px;
  }

  .amount_card_content,
  .amount_selected {
    font-size: 11px;
    text-align: center;
  }
  .donate_button {
    font-size: 10px !important;
    height: 30px;
  }
  .amount_input {
    text-align: center;
    align-items: center;
    flex-direction: row;
    justify-content: start;
    font-size: 15px;
  }
  .fact_check_party_tags_in_mobile {
    display: none;
  }
  
  .donation_second_row_container_ta > h1 {
    font-size: 25px;
  }
  .donation_third_row_container > h6,
  .donation_third_row_container > h5 {
    font-size: medium;
  }
  .donation_third_row_container_ta > h6,
  .donation_third_row_container_ta > h5 {
    font-size: small;
    justify-content: center;
  }
  .donation_footer_container > text {
    font-size: 9px;
  }
  .donation_footer_container_ta > text {
    font-size: 8px;
  }
  .featured_story_image_skeleton {
    height: 350px !important;
  }
  .featured_story_content_skeleton {
    width: 40% !important;
  }
  .featured_story_title_skeleton {
    height: 50px !important;
    width: 100%;
  }
  .top_contributor_main_container {
    height: 160px;
  }
  .secondary_donation_fight_against_container > h1 {
    font-size: 60px;
    font-weight: bold;
  }
  .secondary_donation_fight_against_container > h2 {
    font-weight: bold;
  }
  .single_fact_check_claim_container {
    position: sticky !important;
    top: 140px;
    bottom: 20px !important;
  }
  .join_us_feature_text_ta {
    font-size: 16px;
  }
  .fact_check_browse_categories_title {
    font-size: 30px !important;
  }
  .donation_third_row_container_ta > h5 {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_1024_1439/screen_1024_1439_fact_check.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,sCAAsC;EACxC;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n  .featured_fact_check_thumbnail_overlay_content {\n    height: 120px;\n    width: 69% !important;\n  }\n\n  .featured_fact_check_view_count {\n    font-size: 12px;\n  }\n  .featured_fact_check_thumbnail_overlay_name_and_date {\n    font-size: 12px !important;\n  }\n  .featured_fact_check_button {\n    height: 22px;\n    font-size: 9px;\n  }\n  .featured_story_fact_check_title {\n    font-size: 18px;\n  }\n  .featured_story_fact_check_sub_title {\n    font-size: 15px;\n  }\n  .featured_fact_check_image_component {\n    width: 60% !important;\n    position: relative;\n  }\n  .featured_story_fact_check_container_mobile_view {\n    display: none;\n  }\n\n  .fact_check_trending_stories_title {\n    font-size: 25px;\n  }\n\n  .fact_check_trending_container {\n    border-radius: 8px;\n  }\n  .fact_category_wise_card_container {\n    height: 190px;\n    width: 30%;\n  }\n \n  .fact_check_trending_stories_container {\n    padding: 0px 20px 35px 20px !important;\n  }\n  .fact_check_trending_stories_title_container {\n    height: 70px;\n  }\n  .fact_check_trending_stories_title {\n    font-size: 25px;\n  }\n\n  .featured_fact_check_title {\n    width: 90%;\n  }\n\n  .join_us_feature_text {\n    font-size: 18px;\n  }\n  .home_article_sec_column_inner_row_content_skeleton {\n    width: 100% !important;\n    height: 98% !important;\n  }\n  .home_article_second_column :where(.css-dev-only-do-not-override-zg0ahe).ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n    width: 660px !important;\n    height: 350px !important;\n  }\n  .exposing_fake_news_first_column_image_skeleton {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .category_wise_card_container_skeleton {\n    width: 280px !important;\n    height: 180px !important;\n  }\n  .fact_check_party_container {\n    grid-template-columns: 65% 30% !important;\n  }\n\n  .fact_check_first_column_card_container {\n    height: 400px !important;\n  }\n  .fact_check_party_wise_module_title {\n    font-size: 30px !important;\n  }\n  .donation_first_row_container > text {\n    font-size: 12px;\n  }\n  .donation_first_row_container_ta > text {\n    font-size: 13px;\n  }\n\n  .amount_card_content,\n  .amount_selected {\n    font-size: 11px;\n    text-align: center;\n  }\n  .donate_button {\n    font-size: 10px !important;\n    height: 30px;\n  }\n  .amount_input {\n    text-align: center;\n    align-items: center;\n    flex-direction: row;\n    justify-content: start;\n    font-size: 15px;\n  }\n  .fact_check_party_tags_in_mobile {\n    display: none;\n  }\n  \n  .donation_second_row_container_ta > h1 {\n    font-size: 25px;\n  }\n  .donation_third_row_container > h6,\n  .donation_third_row_container > h5 {\n    font-size: medium;\n  }\n  .donation_third_row_container_ta > h6,\n  .donation_third_row_container_ta > h5 {\n    font-size: small;\n    justify-content: center;\n  }\n  .donation_footer_container > text {\n    font-size: 9px;\n  }\n  .donation_footer_container_ta > text {\n    font-size: 8px;\n  }\n  .featured_story_image_skeleton {\n    height: 350px !important;\n  }\n  .featured_story_content_skeleton {\n    width: 40% !important;\n  }\n  .featured_story_title_skeleton {\n    height: 50px !important;\n    width: 100%;\n  }\n  .top_contributor_main_container {\n    height: 160px;\n  }\n  .secondary_donation_fight_against_container > h1 {\n    font-size: 60px;\n    font-weight: bold;\n  }\n  .secondary_donation_fight_against_container > h2 {\n    font-weight: bold;\n  }\n  .single_fact_check_claim_container {\n    position: sticky !important;\n    top: 140px;\n    bottom: 20px !important;\n  }\n  .join_us_feature_text_ta {\n    font-size: 16px;\n  }\n  .fact_check_browse_categories_title {\n    font-size: 30px !important;\n  }\n  .donation_third_row_container_ta > h5 {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
